import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import ResumeOverview from '../resumeParser/resumeOverview';

export const ParsedResume = ({ open, handleClose, resume }) => {
  return (
    <Dialog
      fullWidth={false}
      maxWidth={'lg'}
      open={open}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title"
    >
      <DialogTitle id="max-width-dialog-title">
        {resume && resume.filename ? resume.filename : 'Resume'} Overview
      </DialogTitle>
      <DialogContent>
        <ResumeOverview json={resume && resume.content ? resume.content : {}} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
